import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import { CancelIcon } from 'assets/icons';
import { useCurrentPopup } from 'Components/Popups';
import { ReactNode, useLayoutEffect, useRef } from 'react';

export interface OverlayWindowProps {
  children?: ReactNode;
  body?: ReactNode;
  title?: ReactNode;
  subTitle?: ReactNode;
  width?: string;
  size?: WindowSize | string;
  titleSize?: TitleSize | string;
  paddingSize?: PaddingSize | string;
  onClose?: () => void;
  rounded?: string;
  border?: string;
  footer?: ReactNode;
}

export enum WindowSize {
  full = 'w-full',
  xl = 'w-[1200px] md-max:w-128 sm-max:w-[100vw] sm-max:h-[100vh]',
  lg = 'w-192 md-max:w-128 sm-max:w-[100vw] sm-max:h-[100vh]',
  md = 'w-128 md-max:w-96 sm-max:w-[100vw] sm-max:h-[100vh]',
  sm = 'w-96 sm-max:w-72',
  xs = 'w-64',
  min = '',
}

export enum TitleSize {
  sm = 'text-sm md-max:text-xs',
  md = 'text-base md-max:text-sm',
}

export enum PaddingSize {
  md = 'px-4 py-2',
  none = '',
}

export default function OverlayWindow({
  children,
  width,
  title,
  titleSize = TitleSize.md,
  subTitle,
  size = WindowSize.md,
  paddingSize = PaddingSize.md,
  rounded = 'rounded-xl',
  border = 'border border-gray-100',
  onClose,
  footer,
  body,
}: OverlayWindowProps) {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={ref}
      className={`${size} ${border} ${rounded} max-h-screen-90 overflow-auto shadow-lg-all relative justify-between flex flex-col bg-white outline-none focus:outline-none`}
      style={{
        width,
      }}
    >
      {title && (
        <DashboardContainerHeader title={title} subTitle={subTitle}>
          {onClose && (
            <span
              className="p-2 cursor-pointer text-red appearance-none background-transparent font-bold uppercase text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
              onClick={onClose}
            >
              <CancelIcon className="text-gray-light" />
            </span>
          )}
        </DashboardContainerHeader>
      )}

      <ScrollContainer
        className={`${paddingSize} ${
          size === WindowSize.lg ? 'flex-1 h-full overflow-y-auto' : ''
        }`}
      >
        {body ? body : children}
      </ScrollContainer>
      {footer && <div className="py-4 px-4">{footer}</div>}
    </div>
  );
}
